import { render, staticRenderFns } from "./despositRecord.vue?vue&type=template&id=55b3d081&"
import script from "./despositRecord.vue?vue&type=script&lang=js&"
export * from "./despositRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports